import DateBox from 'devextreme/ui/date_box';
import { Instrument } from '@iv/model/instrument';
import {
  ChartType,
  IChartFilter,
  ISelectedFilters
} from 'app/charts-dashboard/interfaces/chart.interface';
import { Observable } from 'rxjs';
import { ID } from '@datorama/akita';

export interface IDateBoxItem {
  component: DateBox;
  date: Date;
  view: String;
}

export enum DateBoxTypesEnum {
  DATE = 'date',
  DATE_TIME = 'datetime',
  TIME = 'time'
}

export interface IChartDialog {
  chartVariant: ChartType | null;
  listChartTypes: Observable<ChartType[]>;
  instruments: Instrument[];
}

export interface IChangeStockSeries extends IBaseSymbolDialog {
  instruments: Instrument[];
  filters: IChartFilter[];
  selectedFilters: ISelectedFilters;
  seriesId: ID;
}

export interface IChangeIVDiffStockSeries extends IChangeStockSeries {
  currentPoint: 'first' | 'second';
}

export interface ICompareSymbol extends IBaseSymbolDialog {
  filters: IChartFilter[];
  selectedFilters: ISelectedFilters;
  instruments: Instrument[];
}

export interface ICompareDateDialog extends IBaseSymbolDialog {
  filters: IChartFilter[];
  selectedFilters: ISelectedFilters;
  seriesId: ID;
}

interface IBaseSymbolDialog {
  action: SymbolDialogActionType;
  parentCardId: ID;
}

export interface ICompareDialogOutput extends IBaseSymbolDialog {
  stock: Instrument;
  seriesId: ID;
  selectedFilters: ISelectedFilters;
  filters?: IChartFilter[];
}

export type SymbolDialogActionType =
  SymbolDialogActionEnum.CHANGE_STOCK_IN_COMPARE_SERIES |
  SymbolDialogActionEnum.COMPARE_SERIES |
  SymbolDialogActionEnum.COMPARE_DATE |
  SymbolDialogActionEnum.CHANGE_STOCK_IN_MAIN_SERIES |
  SymbolDialogActionEnum.CHANGE_STOCK_IN_ALL_SERIES |
  SymbolDialogActionEnum.CHANGE_IV_DIFF_STOCK_IN_SERIES |
  SymbolDialogActionEnum.CHANGE_STOCK_IN_INTRADAY_CHART;

export enum SymbolDialogActionEnum {
  COMPARE_SERIES = 'compare-series',
  COMPARE_DATE = 'compare-date',
  CHANGE_STOCK_IN_MAIN_SERIES = 'change-stock-in-main-series',
  CHANGE_STOCK_IN_COMPARE_SERIES = 'change-stock-in-compare-series',
  CHANGE_STOCK_IN_ALL_SERIES = 'change-stock-in-all-series',
  CHANGE_IV_DIFF_STOCK_IN_SERIES = 'change-iv-diff-stock-in-series',
  CHANGE_STOCK_IN_INTRADAY_CHART = 'change-stock-in-intraday-chart'
}
